import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

type DisplayDossierProcessBlocForm = {
    id: number;
    label: string;
    checked: boolean;
};

export type DisplayDossierProcessesBlocFormProps = {
    items: Array<DisplayDossierProcessBlocForm>;
    onToggleItem: (id: number) => void;
};

const DisplayDossierProcessesBlocForm: React.FunctionComponent<DisplayDossierProcessesBlocFormProps> =
    function (props) {
        const { items, onToggleItem } = props;
        const { palette } = useTheme();

        return (
            <Box sx={{ minWidth: '300px' }}>
                <Box sx={{ marginBottom: '16px' }}>
                    <Typography variant="l2dh6">Ajouter une démarche</Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px', paddingTop: '16px' }}>
                        {items.map((item) => (
                            <Box
                                key={item.label}
                                sx={{
                                    border: `1px solid ${palette.primary.main}`,
                                    padding: '8px 8px',
                                    borderRadius: '8px',
                                    marginBottom: '8px',
                                    cursor: 'pointer',
                                    backgroundColor: item.checked
                                        ? palette.primary.light
                                        : 'transparent',
                                }}
                                onClick={() => {
                                    onToggleItem(item.id);
                                }}
                            >
                                <Typography variant="body1">{item.label}</Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Box>
        );
    };

export default DisplayDossierProcessesBlocForm;
